export default "__VITE_ASSET__Uo4zFmkg__"